import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartData,
} from 'chart.js';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useListContext } from 'react-admin';
import { Bar } from 'react-chartjs-2';
import { OrderProviderExternalErrorPeriodChart } from 'types/embedded/orderProviderExternalErrors';
import { formatRangeInputInTz } from 'utils/date';

import {
  StyledCard,
  StyledCardContent,
  StyledCardHeader,
} from './OrderProviderExternalErrorsPeriodChart.styled';
import { OrderProviderExternalErrorsPeriodChartSkeleton } from './OrderProviderExternalErrorsPeriodChartSkeleton';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: {
        boxWidth: 16,
        boxHeight: 16,
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};

const DATE_TIME_MASK = 'dd.MM.yyyy HH:mm';

type Props = { data?: OrderProviderExternalErrorPeriodChart };

export const OrderProviderExternalErrorsPeriodChart: React.FC<Props> = ({ data }) => {
  const translate = useTypedTranslate();
  const { filterValues } = useListContext();

  if (!data) {
    return <OrderProviderExternalErrorsPeriodChartSkeleton />;
  }

  const chartData: ChartData<'bar', number[], string> = {
    labels: data?.labels,
    datasets: data?.datasets,
  };

  const title = `${translate('app.orderProviderExternalErrors.declineEventsForPeriod')} ${formatRangeInputInTz(
    [filterValues?.createdAt?.gte, filterValues?.createdAt?.lte],
    {
      format: DATE_TIME_MASK,
      timezone: filterValues?.timezone,
    },
  )}`;

  return (
    <StyledCard>
      <StyledCardHeader title={title} titleSize="small" />
      <StyledCardContent>
        <Bar data={chartData} options={options} />
      </StyledCardContent>
    </StyledCard>
  );
};
